<div *ngIf="message" class="alert alert-dismissible alert-noctem" style="margin:10px">{{message}}
    <button type="button" class="close" aria-label="Close" (click)="clear()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>